export * from "./solutions-card";
export { SolutionsCard as default } from "./solutions-card";
